export default {
  data() {
    return {
      selectedCarTypeParent: []
    };
  },
  methods: {
    onChangeCarTypeParent() {
      let ids = this.selectedCarTypeParent?.map(item => item.id) ?? [];
      this.filters.zz_car_types_parent_id = ids; 
     
      // 初回のデータ取得時に絶対ローカルストレージに入っている
      // this.changeCondition('zz_car_types_parent_id', ids);
      this.getData();
    },
    checkCarChecked(option) {
      return this.selectedCarTypeParent.some(item => item.id == option.id);
    },
    checkCarCheckedAll() {
      return (
        this.selectedCarTypeParent.length ==
        this.zzCarTypesParent[0].attributes.length
      );
    }
  },
  computed: {
    zzCarTypesParent() {
      let options = [
        {
          selectAll: "すべて",
          attributes:
            this.$store.getters["options/options_tables"].zz_car_types_parent ??
            []
        }
      ];

      return options;
    }
  }
};
